if (!customElements.get("details-disclosure")) {
    class DetailsDisclosure extends HTMLElement {
        constructor() {
            super();
            this.mainDetailsToggle = this.querySelector("details");

            this.addEventListener("keyup", this.onKeyUp);
            this.mainDetailsToggle.addEventListener(
                "focusout",
                this.onFocusOut.bind(this)
            );
        }

        onKeyUp(event) {
            if (event.code.toUpperCase() !== "ESCAPE") return;

            const openDetailsElement = event.target.closest("details[open]");
            if (!openDetailsElement) return;

            const summaryElement = openDetailsElement.querySelector("summary");
            openDetailsElement.removeAttribute("open");
            summaryElement.focus();
        }

        onFocusOut() {
            setTimeout(() => {
                if (!this.contains(document.activeElement)) this.close();
            });
        }

        close() {
            this.mainDetailsToggle.removeAttribute("open");
        }
    }

    customElements.define("details-disclosure", DetailsDisclosure);
        /* ── RÉPARATION 2026-10-12 — LE BOUTON DE PARTAGE NE FAISAIT RIEN ──
         *
         * La classe DetailsDisclosure est déclarée DANS un bloc. Une classe
         * déclarée dans un bloc est liée au bloc, comme une let : elle ne crée
         * AUCUNE variable globale.
         *
         * Or assets/share.js écrit  class ShareButton extends DetailsDisclosure
         * → ReferenceError → customElements.define('share-button') ne s'exécute
         * jamais → le bouton copier n'a aucun écouteur et le presse-papiers
         * reste vide.
         *
         * Cette ligne rend le constructeur visible SANS toucher share.js et
         * SANS changer l'ordre des scripts.
         * Ne pas la retirer sans retirer aussi share.js.
         * ─────────────────────────────────────────────────────────────── */
        window.DetailsDisclosure = DetailsDisclosure;
}
